import {
    provide,
    reactive,
    readonly,
    toRefs,
  } from 'vue';
  
  // We use symbols as a unique identifiers.
  export const UserSettingsStateSymbol = Symbol('User settings provider state identifier');
  export const UserSettingsUpdateSymbol = Symbol('User settings update provider identifier');
  
  export default {
    setup() {
      const state = reactive({
        role: 'USER',
        token: '',
      });

      provide(UserSettingsStateSymbol, toRefs(readonly(state)));
  
      const update = (property, value) => {
        state[property] = value;
      };
      provide(UserSettingsUpdateSymbol, update);
    },
    render() {
      
      return this.$slots.default();
    },
};